import classnames from 'classnames';

interface ClassDictionary {
    [id: string]: unknown;
}

type ClassValue = string | number | ClassDictionary | ClassValue[] | undefined | null | boolean;

export const classes = (component: string, ...classNames: ClassValue[]) =>
    classnames(`elc-${component}`, `js-${component}`, classNames);
